import { observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../../adl-gen/common';
import { DbKey } from '../../../../adl-gen/common/db';
import { Competency } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { PageLayoutFn } from '../../../../ui/common/page-layout/page-layout';
import { ListEntryWithIdentity } from '../../common/list/list-types';
import { ListView } from '../../common/list/list-view';
import { CompetencyListView } from '../../components/lists/competency-list/competency-list-view';

interface CompetencySkillScreenProps {
  pageLayout: PageLayoutFn;
  navigateTo(route: Route): void;
  competencies: MaybeLoading<Paginated<ListEntryWithIdentity<Competency>>>;
}

@observer
export class CompetencySkillScreen extends React.Component<CompetencySkillScreenProps> {
  @observable.ref selectedTabKey: React.ReactText = 0;

  onSelectCompetency = async (competencyId: DbKey<Competency>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'competency',
      id: competencyId
    });
  };

  onCreateCompetency = () => {
    this.props.navigateTo({
      route: 'admin',
      page: 'competency',
      view: 'new'
    });
  };

  renderCompetencyList = observer((competencies: Paginated<ListEntryWithIdentity<Competency>>) => (
    <ListView
      list={competencies}
      fields={CompetencyListView}
      onSelect={this.onSelectCompetency}
      onCreate={this.onCreateCompetency}
    />
  ));

  CompetenciesLoader = () => <Loader state={this.props.competencies} LoadedComponent={this.renderCompetencyList} />;

  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      <this.props.pageLayout title={'Administration'}>
        <this.CompetenciesLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/competency-skill-screen/competency-skill-screen.tsx